import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AuthProvider } from "./components/AuthProvider";
import { OpsLayout } from "./components/OpsLayout";
import { AffiliatePage } from "./pages/AffiliatePage";
import { ContentEditorPage } from "./pages/ContentEditorPage";
import { ContentPage } from "./pages/ContentPage";
import { DestinationsPage } from "./pages/DestinationsPage";
import { ExperiencesPage } from "./pages/ExperiencesPage";
import { GrowthPage } from "./pages/GrowthPage";
import { ListingsPage } from "./pages/ListingsPage";
import { MerchantsPage } from "./pages/MerchantsPage";
import { OperatorsPage } from "./pages/OperatorsPage";
import { OverviewPage } from "./pages/OverviewPage";
import { SettlementPage } from "./pages/SettlementPage";
import { UgcPage } from "./pages/UgcPage";
import { WaitlistPage } from "./pages/WaitlistPage";

const qc = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false } },
});

export function App() {
  return (
    <QueryClientProvider client={qc}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<OpsLayout />} path="/">
              <Route element={<OverviewPage />} index />
              <Route element={<WaitlistPage />} path="waitlist" />
              <Route element={<GrowthPage />} path="growth" />
              <Route element={<ContentPage />} path="content" />
              <Route element={<ContentEditorPage />} path="content/new" />
              <Route element={<ContentEditorPage />} path="content/:slug" />
              <Route element={<AffiliatePage />} path="affiliate" />
              <Route element={<MerchantsPage />} path="merchants" />
              <Route element={<ListingsPage />} path="listings" />
              <Route element={<SettlementPage />} path="settlement" />
              <Route element={<DestinationsPage />} path="destinations" />
              <Route element={<ExperiencesPage />} path="experiences" />
              <Route element={<UgcPage />} path="ugc" />
              <Route element={<OperatorsPage />} path="operators" />
              <Route element={<Navigate replace to="/" />} path="*" />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
